export const FORM_SEARCH_FILTERS = 'FORM_SEARCH_FILTERS';

export const searchFormFields = {
  COMPANY_NAME: 'name',
  REGISTER_CODE: 'registrationCode',
  EICX_CODE: 'eicxCode',
  COMPANY_ROLE: 'legalEntityType',
  COMPANY_STATUS: 'status',
};
